class GuaranteeList extends HTMLElement {
  #controller;
  #openItem = null;

  connectedCallback() {
    this.#controller?.abort();
    this.#controller = new AbortController();
    const { signal } = this.#controller;

    this.querySelectorAll('.guarantee-item--interactive').forEach((item) => {
      const trigger = item.querySelector('.guarantee-item__trigger');
      const tooltip = item.querySelector('.guarantee-item__tooltip');

      trigger.addEventListener('click', () => {
        this.#setOpenItem(this.#openItem === item ? null : item);
      }, { signal });

      // Touch must only toggle on click; emulated hover/focus must not reopen it.
      item.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') this.#setOpenItem(item);
      }, { signal });
      item.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse' && this.#openItem === item) this.#setOpenItem(null);
      }, { signal });
      item.addEventListener('focusin', (event) => {
        if (event.target.matches(':focus-visible')) this.#setOpenItem(item);
      }, { signal });
      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget) && this.#openItem === item) this.#setOpenItem(null);
      }, { signal });

      // Catch taps on the bubble instead of passing them to the next reason below.
      tooltip.addEventListener('click', (event) => {
        if (!event.target.closest('a, button')) this.#setOpenItem(null);
      }, { signal });
    });

    document.addEventListener('click', (event) => {
      if (this.#openItem && !this.#openItem.contains(event.target)) this.#setOpenItem(null);
    }, { capture: true, signal });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !this.#openItem) return;
      const item = this.#openItem;
      if (item.contains(document.activeElement)) item.querySelector('.guarantee-item__trigger').focus();
      this.#setOpenItem(null);
    }, { signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#setOpenItem(null);
  }

  #setOpenItem(item) {
    if (this.#openItem === item) return;
    if (this.#openItem) {
      this.#openItem.classList.remove('is-open');
      this.#openItem.querySelector('.guarantee-item__trigger').setAttribute('aria-expanded', 'false');
      this.#openItem.querySelector('.guarantee-item__tooltip').hidden = true;
    }
    this.#openItem = item;
    if (item) {
      item.classList.add('is-open');
      item.querySelector('.guarantee-item__trigger').setAttribute('aria-expanded', 'true');
      item.querySelector('.guarantee-item__tooltip').hidden = false;
    }
  }
}

if (!customElements.get('guarantee-list-component')) {
  customElements.define('guarantee-list-component', GuaranteeList);
}
